'use client';

import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import FAQSection from '@/components/Faq/FAQSection';
import DefaultLayout from '@/layouts/DefaultLayout';
import Button from '@/components/Button/Button';
import { useRouter } from 'next/navigation';
import { T } from '@tolgee/react';
import { EmailLinks } from '@/utils/emailLink';
import { isGinioneDomain } from '@/utils/clerkApp';

const GinioneNotFoundPage = dynamic(() =>
  import('@/design-system/components/Auth/NotFoundPage').then((mod) => mod.NotFoundPage),
);

const BloomNotFoundPage = () => {
  const router = useRouter();
  return (
    <>
      <div className="p-8 bg-primary">
        <div className="p-16 bg-[url('/img/404.svg')] bg-no-repeat bg-center bg-cover">
          <div className="w-full text-white">
            <div className="w-3/5">
              <h1 className="text-[100px] font-semibold tracking-headerTight leading-tight mb-20">
                <T>404.404.label</T>
              </h1>
              <p className="text-6xl font-semibold tracking-headerTight leading-tight mt-2">
                <T>404.title.label</T>
              </p>
              <p className="text-4xl font-poppins leading-tight tracking-tightest mt-4">
                <T
                  keyName="404.subtitle.label"
                  params={{
                    email: EmailLinks.support(),
                  }}
                />
              </p>
              <div className="flex mt-6 gap-2">
                <Button variant="primary" onClick={() => router.back()} fullWidth={false}>
                  <T>404.button.back.label</T>
                </Button>
                <Button variant="secondary" href="/" fullWidth={false}>
                  <T>404.button.home.label</T>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FAQSection />
    </>
  );
};

const NotFoundPage = () => {
  const [isGinione, setIsGinione] = useState(false);

  useEffect(() => {
    setIsGinione(isGinioneDomain());
  }, []);

  if (isGinione) {
    return <GinioneNotFoundPage />;
  }

  return (
    <DefaultLayout showCategoryNav={false} showFooter={false}>
      <BloomNotFoundPage />
    </DefaultLayout>
  );
};

export default NotFoundPage;
